document.addEventListener("DOMContentLoaded", function () {

  // Hide and reveal menu

  const menuToggle = document.getElementById("mobile-menu-toggle");
  const menuClose = document.getElementById("mobile-menu-close");
  const mobileMenu = document.getElementById("mobile-menu");
  const body = document.querySelector("body");
  const menuCloseTop = document.getElementById("menuCloseTop");
  
  menuToggle.addEventListener("click", function (event) {
    handleToggleMenu();
    event.stopPropagation();
  });
  
  menuClose.addEventListener("click", function (event) {
    handleToggleMenu();
    event.stopPropagation();
  });
  
  menuCloseTop.addEventListener("click", function (event) {
    closeMenu();
    event.stopPropagation();
  });
  
  function handleToggleMenu() {
    menuToggle.classList.toggle("hidden");
    menuClose.classList.toggle("hidden");
    mobileMenu.classList.toggle("translate-x-0");
    body.classList.toggle("overflow-hidden");
  }
  
  function closeMenu() {
    menuToggle.classList.remove("hidden");
    menuClose.classList.add("hidden");
    mobileMenu.classList.remove("translate-x-0");
    body.classList.remove("overflow-hidden");
  }

  // Menu items open on click

  const submenuItems = document.querySelectorAll(".has-submenu .angle");

  submenuItems.forEach((item) => {
    let isOpen = false;
    item.addEventListener("click", function (event) {
      submenuItems.forEach((item) => {
        item.nextElementSibling.style.maxHeight = '0';
      })
      const submenu = item.nextElementSibling;
      if (isOpen) {
          submenu.style.maxHeight = '0'; // Close the box by setting height to 0
      } else {
          submenu.style.maxHeight = '400px'; // Open the box by setting height to auto
      }
      isOpen = !isOpen;
    });
  });

  // Mobile menu shop and info buttons

  const mobileShopBtn = document.getElementById("mobileShopBtn");
  const mobileInfoBtn = document.getElementById("mobileInfoBtn");
  const mobileShopMenu = document.getElementById("mobileShopMenu");
  const mobileInfoMenu = document.getElementById("mobileInfoMenu");

  mobileShopBtn.addEventListener("click", function (event) {
    mobileShopMenu.classList.remove("hidden");
    mobileInfoMenu.classList.add("hidden");
    mobileInfoBtn.classList.remove("bg-black", "text-white");
    mobileInfoBtn.classList.add("bg-white", "text-black", "shadow-xl");
    mobileShopBtn.classList.add("bg-black", "text-white");
    mobileShopBtn.classList.remove("bg-white", "text-black", "shadow-xl");
  });

  mobileInfoBtn.addEventListener("click", function (event) {
    mobileShopMenu.classList.add("hidden");
    mobileInfoMenu.classList.remove("hidden");
    mobileInfoBtn.classList.add("bg-black", "text-white", "shadow-xl");
    mobileInfoBtn.classList.remove("bg-white", "text-black");
    mobileShopBtn.classList.remove("bg-black", "text-white", "shadow-xl");
    mobileShopBtn.classList.add("bg-white", "text-black");
  });

  // Desktop menu overlay

  const items = document.querySelectorAll('.secondary-menu-item');
  const bdy = document.querySelector('body');

  function toggleClass(event) {
    bdy.classList.remove('overlay');
    bdy.classList.add('overlay');
  }

  function removeClass() {
    bdy.classList.remove('overlay');
  }

  items.forEach(item => {
    item.addEventListener('mouseenter', toggleClass);
    item.addEventListener('mouseleave', removeClass);
  });


  // Search panel
  var searchPanel = document.getElementById('search-panel');
  var toggleButtons = document.querySelectorAll('.toggle-search-panel');

  function toggleSearchPanel() {
    // Toggle visibility of the search panel and animate the transition
    if (searchPanel.style.top === '-100%' || searchPanel.style.top === '') {
      searchPanel.style.top = '0%';
    } else {
      searchPanel.style.top = '-100%';
    }
  }

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', toggleSearchPanel);
  });

  document.addEventListener('click', function (event) {
    // Close the search panel if the click is outside of it
    if (!searchPanel.contains(event.target) && !Array.from(toggleButtons).some(btn => btn.contains(event.target))) {
      searchPanel.style.top = '-100%';
    }
  });


});

